// 
// Todo Tasks
//

let Todo = function() {
	let $todo = $(".c-todo"),
		$todoInput = $(".c-todo__input");

	$todo.on('click', function(e){
		let $target = $(e.target);
		if ($target.closest($todoInput).length) {
			$(this)
				.closest($todo)
				.toggleClass('is-completed');
		}
	});
};
